import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetMy = () => {
	const [fetchResult, fetchRequest] = useFetch()
	const [userRole] = useRoleCookie()

	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/my`

		fetchRequest('GET', url)
	}, [])

	return [fetchResult]
}

export default useGetMy
